import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import {
  getAddToCart,
  getBranchId,
  // getBranchName,
  getCustomerId,
  getEstimationId,
  setEstimationId,
  setPaymentUrl,
} from "utility/HeaderConfig";
import moment from "moment";
import { motion } from "framer-motion";
import { getProduct } from "api/ProductApi";
import { useNavigate } from "react-router-dom";
import success from "images/OrderStatus/success.gif";
import decline from "images/OrderStatus/decline.gif";
import { useLocation } from "react-router-dom";
import { SALES_ACCOUNTS, utcDateToCurrentDate } from "../utility/Constant";
import ShippingAddress from "components/ShippingAddress";
import OrderDetails from "components/OrderDetails";
import { toast } from "react-hot-toast";
import { filterFormatToDate } from "utility/Constant";
import { useCartContext } from "context/UseCartContext";
import CheckoutProgressBar from "components/CheckoutProgressBar";
import ChoosePaymentMethod from "components/ChoosePaymentMethod";
import {
  getCcavenueOrderStatusData,
  getPayULinkData,
  // paymentOrderStatus,
} from "../api/AppConfigApi";
import {
  getAllExpenseCategory,
  getAllPaymentMode,
  getByLedgerName,
} from "../api/CheckOutApi";
import { getAllDomainEmployeeDetails } from "../api/EmployeeApi";
import {
  createEstimationData,
  getDayCloseData,
  getDefaultFinancialYr,
  getOrderStatusId,
} from "../utility/UtilFunction";
import { createSaleItems } from "../utility/CreateSale";
import {
  getInvoiceId,
  setAddToCart,
  setInvoiceId,
} from "../utility/HeaderConfig";
import { useVisibilityChange } from "hooks/useVisibilityChange";
import "styles/checkout.css";
import AffordabilityWidget from "./AffordabilityWidget";

const StyledDiv = tw.div`font-display overflow-hidden`;
const BgColor = tw.div`bg-zinc-100 py-4 sm:py-10`;
export const NavLink = tw.a`no-underline`;

export default () => {
  const documentVisibility = useVisibilityChange();

  const [address, setAddress] = useState(true);
  const [payment, setPayment] = useState(false);
  const [viewCart, setViewCart] = useState([]);
  const [total, setTotal] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [opengateWay, setOpengateWay] = useState(false);
  const [orderId, setOrderId] = useState('');
  const [Details, setDetails] = useState({
    customerName: "",
    mobileNo: "",
    email: "",
    address1: "",
    address2: "",
    pincode: "",
    landmark: "",
    districtName: "",
    stateName: "",
    countryName: "",
    customerId: "",
    customerCurrentCredit: 0,
    customerCurrentDebit: 0,
  });

  const location = useLocation();
  //eslint-disable-next-line
  const myparam = location.state;
  const history = useNavigate();

  const [saleId, setSaleId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [orderStatusDetails, setOrderStatusDetails] = useState({order_card_name: 'UPI'});
  const [orderStatusValue, setOrderStatusValue] = useState("");
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [onlinePaymentEmplyId, setOnlinePaymentEmplyId] = useState("");
  const [invoiceExCategoryId, setInvoiceExCategoryId] = useState("");
  const [defaultFinalFinancialYr, setDefaultFinalFinancialYr] = useState("");
  const [soldOrderStatusId, setSoldOrderStatusId] = useState("");
  const [ledgerNameDetails, setLedgerNameDetails] = useState({
    primaryGroupId: "",
    subGroupId: "",
    ledgerNameId: "",
    ledgerName: "",
  });
  // const isClearTimeoutElement = useRef(null);
  const isSaleProcessingElement = useRef(false);
  const [saleDayCloseDate, setSaleDayCloseDate] = useState("");
  const [estiDayCloseDate, setEstiDayCloseDate] = useState("");
  const [estiOrderStatusId, setEstiOrderStatusId] = useState("");
  const [estiCompOrderStatusId, setEstiCompOrderStatusId] = useState("");

  useEffect(() => {
    getCartList();
    getPaymentModeList();
    getOnlinePaymentEmployeeId();
    getExpenseCategoryId();
    getDefaultFinalcialYrId();
    getSoldStatusId();
    getLedgerNameDetails();
    getSaleDayCloseDate();
    getEstiDayCloseDate();
    getEstiOrderStatusId();
    getEstiCompletedOrderStatusId();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {    
    if (isSaleProcessingElement.current && orderStatusValue) {
      const invoiceId = JSON.parse(getInvoiceId())?.invoiceId;
      updatePaymentStatus(invoiceId, Details);
    }
    // eslint-disable-next-line
  }, [orderStatusValue]);

  useEffect(() => {
    if (document.visibilityState === "visible" && getInvoiceId() && payment)
      Promise.all([checkOrderStatus()]).then((data) => {
        setOrderStatusDetails(data[0].response);
        setOrderStatusValue(data[0].response.order_status);
      });
    // eslint-disable-next-line
  }, [documentVisibility]);

  const viewCartList = () => {
    let dataList = [];
    let cartArray = [];
    let totalAmount = 0;

    const newArray =
      getAddToCart() &&
      JSON.parse(getAddToCart()).filter(
        (cartItem) => cartItem.branchId === getBranchId()
      );

     if (newArray?.length > 0 && location?.state?.isBuyNow !== 'buyNow') {
      newArray.forEach((element, idx) => {
        let filter = {
          branch: getBranchId(),
          id: element.id,
          beforeCreatedAt: filterFormatToDate(moment().format("YYYY-MM-DD")),
        };

        getProduct(10, filter).then((res) => {
          if (res.response.content.length > 0) {
            const product = res.response.content[0];
            dataList.push(product);
            totalAmount += res.response.content[0].discountAmt > 0 ? parseFloat(res.response.content[0].discountAmt) : parseFloat(res.response.content[0].total);
            cartArray.push(product)

            setTotal(totalAmount.toFixed(2));
            // if (prdctId === res.response.content[0].id) {
            // }
          }
          }).catch((error) => {
            console.error("Error fetching product data:", error);
          });
      });
      setViewCart(cartArray)
    } else {
      
        let filter = {
          branch: getBranchId(),
          id: location.state.Details.id,
          beforeCreatedAt: filterFormatToDate(moment().format("YYYY-MM-DD")),
        };

        getProduct(10, filter).then((res) => {
          if (res.response.content.length > 0) {
            const product = res.response.content[0];
            dataList.push(product);
            totalAmount = product.total;
            const { prdctId } = location.state || {};
            if (prdctId === res.response.content[0].id) {
              setTotal(res.response.content[0].discountAmt > 0 ? res.response.content[0].discountAmt : res.response.content[0].total);
              setViewCart(res.response.content);
            }
          }
        }).catch((error) => {
          console.error("Error fetching product data:", error);
        });
    }
  };

  const getCartList = () => {
    viewCartList();
  };

  //--------------- Create Sale meta data ---------------------------//

  const getPaymentModeList = () => {
    const paymentModeRes = getAllPaymentMode();
    paymentModeRes.then((data) => {
      setPaymentModeList(data.response);
    });
  };

  const getOnlinePaymentEmployeeId = () => {
    const employeeFilterData = {
      name: "ONLINEPAYMENT",
    };
    const employeeData = getAllDomainEmployeeDetails(employeeFilterData);
    employeeData.then((data) => {
      let employeeIdResponse = data.response;
      setOnlinePaymentEmplyId(employeeIdResponse[0]?.id);
    });
  };

  const getExpenseCategoryId = () => {
    const filterData = {
      name: "invoice",
    };
    const responseData = getAllExpenseCategory(filterData);
    responseData.then((data) => {
      setInvoiceExCategoryId(data.response[0].id);
    });
  };

  const getDefaultFinalcialYrId = async () => {
    const finalcialYrResData = await getDefaultFinancialYr();
    if (finalcialYrResData && finalcialYrResData.length > 0)
      setDefaultFinalFinancialYr(finalcialYrResData[0].id);
  };

  const getSoldStatusId = async () => {
    const soldStatusResData = await getOrderStatusId(
      "Advance_Without_Delivery"
    );
    if (soldStatusResData && soldStatusResData.response.length > 0)
      setSoldOrderStatusId(soldStatusResData.response[0].id);
  };

  const getLedgerNameDetails = async () => {
    const responseData = await getByLedgerName(SALES_ACCOUNTS);
    if (responseData && responseData.id !== undefined) {
      setLedgerNameDetails({
        primaryGroupId: responseData.metaLedgerPrimaryGroupId,
        subGroupId: responseData.metaLedgerSubGroupId,
        ledgerNameId: responseData.id,
        ledgerName: responseData.name,
      });
    }
    return responseData;
  };

  const getSaleDayCloseDate = async () => {
    const branchId = getBranchId();
    const dayCloseData = await getDayCloseData("sales", branchId);
    if (dayCloseData && dayCloseData.response.length > 0) {
      setSaleDayCloseDate(
        utcDateToCurrentDate(dayCloseData.response[0].activeDate)
      );
    }
  };

  const getEstiDayCloseDate = async () => {
    const branchId = getBranchId();
    const estiDayCloseData = await getDayCloseData("estimation", branchId);
    if (estiDayCloseData && estiDayCloseData.response.length > 0) {
      setEstiDayCloseDate(
        utcDateToCurrentDate(estiDayCloseData.response[0].activeDate)
      );
    }
  };

  const getEstiOrderStatusId = async () => {
    const estiOrderStatusData = await getOrderStatusId("estimation");
    if (estiOrderStatusData && estiOrderStatusData.response.length > 0) {
      setEstiOrderStatusId(estiOrderStatusData.response[0].id);
    }
  };

  const getEstiCompletedOrderStatusId = async () => {
    const estiCompOrderStatusData = await getOrderStatusId(
      "estimation_completed"
    );
    if (
      estiCompOrderStatusData &&
      estiCompOrderStatusData.response.length > 0
    ) {
      setEstiCompOrderStatusId(estiCompOrderStatusData.response[0].id);
    }
  };

  //-----------------  Initiate Create Sale and Update Payment Status -------------//
  const { dispatch } = useCartContext();

  const updatePaymentStatus = async (invoiceId, Details) => {
    let estimationId = getEstimationId();
    let estimationDetails = [
      {
        financialYear: defaultFinalFinancialYr,
        id: estimationId,
        reason: null,
        status: estiCompOrderStatusId,
      },
    ];
    await createSaleItems(
      estimationDetails,
      viewCart,
      Details,
      paymentModeList,
      defaultFinalFinancialYr,
      ledgerNameDetails,
      onlinePaymentEmplyId,
      soldOrderStatusId,
      invoiceExCategoryId,
      saleDayCloseDate,
      estiDayCloseDate,
      estiOrderStatusId,
      orderStatusDetails
    )
      .then(
        (data) => {
          setSaleId(data.response.id);
          setPaymentStatus("success");
          setLoading(false);
          setPaymentUrl("");
          setInvoiceId(JSON.stringify({ invoiceId: "" }));
          setAddToCart(JSON.stringify([]));
          isSaleProcessingElement.current = false;
          setOrderStatusValue("");
          dispatch({ type: "ADD", payload: JSON.parse(getAddToCart()) });
        },
        (err) => {
          if (err.response) {
            let message = err.response.data.displayMessage;
            isSaleProcessingElement.current = false;
            setPaymentStatus(message);
            setOrderStatusValue("");
            // setEstimationId("");
            setLoading(false);
            toast.error(message, {
              duration: 1000,
              position: "top-right",
            });
          }
        }
      )
      .catch((err) => {
        toast.error(err, {
          duration: 1000,
          position: "top-right",
        });
        let message = err.response.data.displayMessage;
        isSaleProcessingElement.current = false;
        setOrderStatusValue("");
        setLoading(false);
        setPaymentStatus(message);
      });
  };

  let CartItem = [];
  viewCart.forEach((data) => {
    CartItem.push({
      productId: data.id,
      productCode: data.productCode,
      basePrice: data.basePrice,
      tax: data.saleTaxList,
      total: data.total,
      todayRate: data.todayRate,
      ocAmt: data.otherCharge,
    });
  });

  // console.log(CartItem,"CartItem");

  const OrderStatus = async () => {
    setLoading(true);
    setOpengateWay(true);
    // const productCode = viewCart.reduce((result, item) => {
    //   return `${result}${result ? "," : ""}${item.productCode}`;
    // }, "");
    const saleRelatedDetails = {
      paymentModeList,
      defaultFinalFinancialYr,
      ledgerNameDetails,
      onlinePaymentEmplyId,
      soldOrderStatusId,
      invoiceExCategoryId,
      saleDayCloseDate,
      estiDayCloseDate,
      estiOrderStatusId,
      estiCompOrderStatusId,
    };
    const estiRes = await createEstimationData(CartItem, saleRelatedDetails);    
    // if (estiRes.response.id !== "") {
    //   setEstimationId(estiRes.response.id);
    //   const randomNum = Math.floor(100000 + Math.random() * 900000).toString();
    //   const requestData = {
    //     amount: Math.trunc(total),
    //     branchId: getBranchId(),
    //     branchName: getBranchName(),
    //     currencyCode: "INR",
    //     customerEmail: Details.email,
    //     customerId: Details.customerId,
    //     customerName: Details.customerName,
    //     customerPhone: Details.mobileNo,
    //     gatewayName: "CCAVENUE",
    //     orderId: randomNum,
    //     paymentPurpose: "ECOMM_WEB_SALES",
    //     productDesc: randomNum,
    //     // productDesc :estiRes.response.id,
    //     usageFrom: "WEB",
    //   };
    //   getCcavenuePaymentLinkData(JSON.stringify(requestData)).then((datas) => {
    //     Promise.all([
    //       setInvoiceId(
    //         JSON.stringify({
    //           invoiceId: datas.response.invoice_id,
    //         })
    //       ),
    //       datas.response.tiny_url,
    //     ]).then((item) => {
    //       const tinyUrl = item[1];
    //       setLoading(true);
    //       // setPayment(true);
    //       if (tinyUrl) {
    //         setTimeout(() => {
    //           setLoading(false);
    //           setPaymentUrl(tinyUrl);
    //           window.open(tinyUrl);
    //         }, 5000);
    //       } else {
    //         console.error("Invalid tiny URL:", tinyUrl);
    //         setLoading(false);
    //       }
    //     });
    //   });
    // }
     if (estiRes.response.id !== "") {
      setEstimationId(estiRes.response.id);
      const requestData = {
        customerId: Details.customerId,
        chitId: estiRes.response.id,
        branchId: getBranchId(),
        paymentPurpose: "ECOMM_WEB_SALES",
        requestChannel: "WEB",
        gateWayName: "PAYU",
        paymentAmount: total.toFixed(2),
       };
       const responseData = getPayULinkData(requestData)
       responseData.then(
         data => {
           //  onlinePaymentStatus('response', data.response);
           const orderId = data.response.orderId;
           setOrderId(orderId)
         }
       )
     }
  };

  // const onlinePaymentStatus = async (data, payData) => {
  //   let gatewayName = "PAYU";
  //   let branchId = getBranchId();
  //   let branchName = getBranchName();
  //   const paymentStatus = await paymentOrderStatus(branchName,payData.orderId);
  //   if (paymentStatus.response[0]?.status.toLowerCase() === "captured") {
  //     updatePaymentStatus('', Details);
  //     toast.success("Payment Successfull!", {
  //       duration: 2000,
  //       position: "top-right",
  //     });
  //   } else {
  //     toast.error("Payment Failed!", {
  //       duration: 2000,
  //       position: "top-right",
  //     });
  //   }

  // }

// for unsuccessful payment
  const checkOrderStatus = () => {
    setLoading(true);
    const invoiceId = JSON.parse(getInvoiceId())?.invoiceId;
    const responseData = getCcavenueOrderStatusData(invoiceId);
    responseData.then((data) => {
      if ((data.response.order_status.toLowerCase() === "successful") || (data.response.order_status.toLowerCase() === "shipped")) {
        isSaleProcessingElement.current = true;
      }
      // Unsuccessful Payment check for testing purpose
      // if (data.response.order_status && (data.response.order_status.toLowerCase() === "unsuccessful" || data.response.order_status.toLowerCase() === "aborted")) {
      //   isSaleProcessingElement.current = true;
      // }
    });
    return responseData;
  };

  const changeComponent = (data) => {
    setDetails({ ...Details, ...data, customerId: getCustomerId() });
    setAddress(false);
    setPayment(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const clearSuccessData = () => {
    if (paymentStatus === "success" && saleId !== "") {
      history("/MyPurchase", {state:{ type: "myorder"} });
      setViewCart([]);
    }
  };

  return (
    <>
    <StyledDiv>
      <BgColor>
        <div className="container">
          <CheckoutProgressBar address={address} payment={payment} />
          <div className="row my-sm-5 my-3">
            <div className="col-md-8">
              <div className="bg-gray-300">
                <div className="py-12">
                  <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg md:max-w-xl mx-2">
                    <div
                      className="px-5"
                      tw="py-2 border-b-4 border-custom-100"
                    >
                      <b className="PaymentStyle">
                        {address && "Shipping Address"}
                        {payment && "Payment Details"}
                      </b>
                    </div>
                    <div className="px-sm-5 py-2 px-2 py-sm-4">
                      {viewCart.length > 0 ? (
                        <>
                          {address && (
                            <ShippingAddress
                              onClick={changeComponent}
                              viewCart={viewCart}
                              total={total}
                            />
                          )}
                        </>
                      ) : (
                        <div className="w-100 py-3">
                          <div className="cart-wrapper">
                            <div className="cart-empty-wrapper text-center">
                              <div className="col-md-12 empty-wrapper">
                                <img
                                  className="trash-icon m-auto"
                                  tw=" w-3/5 sm:w-1/4"
                                  alt="cart empty img"
                                  src="data:image/svg+xml;base64,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"
                                />
                                <h3 tw="text-custom-100 uppercase py-5 font-extrabold">
                                  Your Cart is Empty
                                </h3>
                                <button
                                  className="primary-btn cart-btns false  py-3 px-5 rounded"
                                  onClick={() => history("/")}
                                >
                                  Continue Shopping
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {payment && (
                        <ChoosePaymentMethod
                          Loading={Loading}
                          OrderStatus={OrderStatus}
                        // createSaleItems={updatePaymentStatus}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <OrderDetails viewCart={viewCart} total={total} />
          </div>
        </div>
        {paymentStatus !== "" && (
          <>
            <motion.div
              initial={{ x: "700px", opacity: 0, scale: 0.5 }}
              animate={{ x: 0, opacity: 1, scale: 1 }}
              tw="justify-center  flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none "
            >
              <div tw="relative" className=" col-md-7 col-lg-6 col-xl-5  ">
                <div
                  className="box "
                  tw="shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none "
                  style={{
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    backgroundColor: `${paymentStatus.toLowerCase() === "success"
                        ? "#f7f7f7"
                        : "#fff"
                      }`,
                  }}
                >
                  <div
                    style={{ padding: "10px" }}
                    className="box-inner"
                    tw="flex-wrap sm:flex items-start justify-center items-center p-2 border-solid border-custom-100 rounded-t"
                  >
                    <div className="text-center">
                      <img
                        src={`${paymentStatus.toLowerCase() === "success"
                            ? success
                            : decline
                          } `}
                        alt="Payment Success"
                        className="w-50 m-auto"
                      />
                      <div className="pb-3">
                        <h4
                          tw="text-2xl my-2 leading-8 uppercase tracking-wider"
                          className={`${paymentStatus.toLowerCase() === "success"
                              ? "text-success"
                              : "text-danger"
                            }`}
                        >
                          Payment {paymentStatus} !
                        </h4>
                        <h5
                          tw="text-xl my-2 leading-8 uppercase tracking-wider"
                          className={`${paymentStatus.toLowerCase() === "success"
                              ? "text-success"
                              : "text-danger"
                            }`}
                        >
                          Your Order Has Been {paymentStatus} !
                        </h5>
                      </div>
                      <div className="pt-4 py-sm-3 d-flex justify-content-evenly">
                        <button
                          className="primary-btn cart-btns false hoverEffect py-2 px-3 px-sm-4 rounded-pill"
                          onClick={() => history("/")}
                        >
                          <span>Continue Shopping</span>
                        </button>
                        <button
                          className="primary-btn cart-btns false hoverEffect py-2 px-3 px-sm-4 rounded-pill"
                          onClick={
                            () => clearSuccessData()
                            // history.push("/MyPurchase", { type: "myorder" })
                          }
                        >
                          <span>Order Details</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            <div tw="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        )}
      </BgColor>
      </StyledDiv>

      {opengateWay && (
        <div
          className="custom-modal-overlay d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
          }}
        >
          <div
            className="custom-modal-content p-4 rounded"
            style={{
              width: "450px",
              background: "#fff",
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease",
            }}
          >
            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <button
                className="btn btn-sm btn-light"
                onClick={() => setOpengateWay(false)}
              >
                ✕
              </button>
            </div>

            {/* BODY — PUT YOUR COMPONENT HERE */}
            {orderId!=="" ? (
            <div>
              {/* {console.log(total, 'total')} */}
              <div className="mt-3">
                <AffordabilityWidget
                  payuKey="Kv9ij7"
                  amount={Math.trunc(total)}
                />
              </div>
            </div>
            ):null}
          </div>
        </div>
      )}
    </>
  );
};
